import { useContext, useMemo } from "react"
import { Link, useLocation } from "react-router-dom"
import Context from "../components/Context"
import { ADMIN_LOGOUT } from "../components/ApiRoutes"
import { postData } from "../components/Helper"
import { useNavigate } from "react-router-dom"
import Dropdown from 'react-bootstrap/Dropdown';

const AdminHeader = () => {
    const location = useLocation()
    const [context, setContext] = useContext(Context)
    const checkLocation = (url, base = false) => {
        let match = url.some((l) => location.pathname.match(l));
        if (base && !match) {
            match = base.some((l) => location.pathname === l);
        }
        return match;
    }

    return (<>
        <div className="header-area header-sticky d-none d-lg-block">
            <div className="container position-relative">
                <div className="row align-items-center">
                    <div className="col-lg-3">
                        <div className="header-logo">
                            <Link to="/">
                                <img src="/assets/images/logo.png" width="154" height="46" alt="Logo" />
                            </Link>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="header-menu">
                            <NavBar context={context} checkLocation={checkLocation} />
                        </div>
                    </div>
                    <div className="col-lg-3">
                        <AuthBar context={context} setContext={setContext} checkLocation={checkLocation} />
                    </div>
                </div>
            </div>
        </div>
        <div className="header-mobile section d-lg-none">
            <div className="header-mobile-top header-sticky">
                <div className="container">
                    <div className="row row-cols-3 gx-2 align-items-center">
                        <div className="col">
                            <div className="header-toggle">
                                <button className="mobile-menu-open" data-bs-toggle="offcanvas" data-bs-target="#offcanvasMenu">
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </button>
                            </div>
                        </div>
                        <div className="col">
                            <div className="header-logo text-center">
                                <Link to="/">
                                    <img src="/assets/images/logo.png" width="154" height="46" alt="Logo" />
                                </Link>
                            </div>
                        </div>
                        <div className="col ms-auto">
                            <div className="header-meta">
                                <AuthBar context={context} setContext={setContext} checkLocation={checkLocation} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div className="offcanvas offcanvas-start" tabIndex="-1" id="offcanvasMenu">
            <div className="offcanvas-body">
                <div className="canvas-menu">
                    <div className="admin-logobox p-2">
                        <Link to="/" title="Home">
                            <img src="/assets/images/logo.png" width="154" height="46" alt="Logo" />
                        </Link>
                        <button type="button" className="btn btn-close border-0 pt-4 px-0 float-end" data-bs-toggle="offcanvas" data-bs-target="#offcanvasMenu" title="Menu Close"></button>
                    </div>
                    <nav className="mobile-header-menu">
                        <NavBar context={context} checkLocation={checkLocation} />
                    </nav>
                </div>
            </div>
        </div>
    </>)
}

export default AdminHeader

const NavBar = ({ context, checkLocation }) => {
    const token = useMemo(() => {
        return ((context && context.auth) || localStorage.getItem('jobman-token')) ? true : false
    }, [context]);

    return (<>
        <ul className="nav-menu">
            {token && <>
                <li className={checkLocation(['contact']) ? 'active pe-none' : ''}>
                    <Link to="contact" data-bs-dismiss="offcanvas" aria-label="Close">Contacts</Link>
                </li>
                <li className={checkLocation(['leads']) ? 'active pe-none' : ''}>
                    <Link to="leads" data-bs-dismiss="offcanvas" aria-label="Close">Leads</Link>
                </li>
                <li className={checkLocation(['admin-quote']) ? 'active pe-none' : ''}>
                    <Link to="admin-quote" data-bs-dismiss="offcanvas" aria-label="Close">Quotations</Link>
                </li>
                <li className={checkLocation(['admin-jobs']) ? 'active pe-none' : ''}>
                    <Link to="admin-jobs" data-bs-dismiss="offcanvas" aria-label="Close">Jobs</Link>
                </li>
                <li className={checkLocation(['insaurence']) ? 'active pe-none' : ''}>
                    <Link to="insaurence" data-bs-dismiss="offcanvas" aria-label="Close">Insurance</Link>
                </li>

                <li className="lbs-multilevel">
                <Dropdown>
                    <Dropdown.Toggle variant="success" id="dropdown-basic" className={checkLocation(['lead-task-link','job-task-link']) ? 'active ' : ''}>
                        Task Links
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                        <Dropdown.Item href="/admin/job-task-links" className={checkLocation(['job-task-link']) ? 'active pe-none' : ''}>JOB TASK LINKS</Dropdown.Item>
                        <Dropdown.Item href="/admin/lead-task-links" className={checkLocation(['lead-task-link']) ? 'active pe-none' : ''}>LEAD TASK LINKS</Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
                </li>
            </>}
        </ul>
    </>)
}




const AuthBar = ({ context, setContext, checkLocation }) => {
    const token = useMemo(() => {
        return ((context && context.auth) || localStorage.getItem('jobman-token')) ? true : false
    }, [context]);

    const navigate = useNavigate()

    const logout = (e) => {
        e.preventDefault()
        postData(ADMIN_LOGOUT, 'POST', '', true, false, (res) => {
            if (res.success) {
                setContext(prevState => ({ ...prevState, auth: null }))
                localStorage.removeItem("jobman-token");
                localStorage.removeItem("jobman-admin");
                navigate("/admin/login")
            }
        })
    }

    return (<>
        {token ? <>
            <div className="header-meta">
                <div className="dropdown">
                    <Link className="action" data-bs-toggle="dropdown"><i className="pe-7s-user"></i></Link>
                    <ul className="dropdown-menu dropdown-profile dropdown-menu-end ">
                        <li className={checkLocation(['dashboard'], ['/admin', '/admin/']) ? 'active pe-none' : ''}>
                            <Link to="/admin/dashboard">Dashboard</Link>
                        </li>
                        <li className={checkLocation(['change-password']) ? 'active pe-none' : ''}>
                            <Link to="/admin/change-password">Change Password</Link>
                        </li>
                        <li className={checkLocation(['home']) ? 'active pe-none' : ''}>
                            <Link to="/login" onClick={logout}>Logout</Link>
                        </li>
                    </ul>
                </div>
            </div>
        </> : <>
            <div className="text-end">
                <Link to="/admin/login" className="btn btn-sm btn-primary">Login</Link>
            </div>
        </>}
    </>)
}